/**
 * Stripe merchant category codes (ISO 18245) as Stripe lists them, with the
 * ones Stripe restricts flagged. Shared by the native wizard and the web one.
 */
export interface StripeMccOption {
  mcc: string;
  key: string;
  label: string;
  restricted: boolean;
}

export const stripeMccOptions: StripeMccOption[] = [
  {
    mcc: "7623",
    key: "ac_refrigeration_repair",
    label: "A/C, Refrigeration Repair",
    restricted: false,
  },
  {
    mcc: "8931",
    key: "accounting_bookkeeping_services",
    label: "Accounting/Bookkeeping Services",
    restricted: false,
  },
  {
    mcc: "7311",
    key: "advertising_services",
    label: "Advertising Services",
    restricted: false,
  },
  {
    mcc: "0763",
    key: "agricultural_cooperative",
    label: "Agricultural Cooperative",
    restricted: false,
  },
  {
    mcc: "4511",
    key: "airlines_air_carriers",
    label: "Airlines, Air Carriers",
    restricted: true,
  },
  {
    mcc: "4582",
    key: "airports_flying_fields",
    label: "Airports, Flying Fields",
    restricted: false,
  },
  {
    mcc: "4119",
    key: "ambulance_services",
    label: "Ambulance Services",
    restricted: true,
  },
  {
    mcc: "7996",
    key: "amusement_parks_carnivals",
    label: "Amusement Parks/Carnivals",
    restricted: true,
  },
  {
    mcc: "5937",
    key: "antique_reproductions",
    label: "Antique Reproductions",
    restricted: false,
  },
  {
    mcc: "5932",
    key: "antique_shops",
    label: "Antique Shops",
    restricted: false,
  },
  {
    mcc: "7998",
    key: "aquariums",
    label: "Aquariums",
    restricted: false,
  },
  {
    mcc: "8911",
    key: "architectural_surveying_services",
    label: "Architectural/Surveying Services",
    restricted: false,
  },
  {
    mcc: "5971",
    key: "art_dealers_and_galleries",
    label: "Art Dealers and Galleries",
    restricted: false,
  },
  {
    mcc: "5970",
    key: "artists_supply_and_craft_shops",
    label: "Artists Supply and Craft Shops",
    restricted: false,
  },
  {
    mcc: "7531",
    key: "auto_body_repair_shops",
    label: "Auto Body Repair Shops",
    restricted: false,
  },
  {
    mcc: "7535",
    key: "auto_paint_shops",
    label: "Auto Paint Shops",
    restricted: false,
  },
  {
    mcc: "7538",
    key: "auto_service_shops",
    label: "Auto Service Shops",
    restricted: false,
  },
  {
    mcc: "5531",
    key: "auto_and_home_supply_stores",
    label: "Auto and Home Supply Stores",
    restricted: false,
  },
  {
    mcc: "5542",
    key: "automated_fuel_dispensers",
    label: "Automated Fuel Dispensers",
    restricted: false,
  },
  {
    mcc: "8675",
    key: "automobile_associations",
    label: "Automobile Associations",
    restricted: false,
  },
  {
    mcc: "5533",
    key: "automotive_parts_and_accessories_stores",
    label: "Automotive Parts and Accessories Stores",
    restricted: false,
  },
  {
    mcc: "5532",
    key: "automotive_tire_stores",
    label: "Automotive Tire Stores",
    restricted: false,
  },
  {
    mcc: "9223",
    key: "bail_and_bond_payments",
    label:
      "Bail and Bond Payments (payment to the surety for the bond, not the actual bond paid to the government agency)",
    restricted: true,
  },
  {
    mcc: "5462",
    key: "bakeries",
    label: "Bakeries",
    restricted: false,
  },
  {
    mcc: "7929",
    key: "bands_orchestras",
    label: "Bands, Orchestras",
    restricted: false,
  },
  {
    mcc: "7230",
    key: "barber_and_beauty_shops",
    label: "Barber and Beauty Shops",
    restricted: false,
  },
  {
    mcc: "7995",
    key: "betting_casino_gambling",
    label: "Betting/Casino Gambling",
    restricted: true,
  },
  {
    mcc: "5940",
    key: "bicycle_shops",
    label: "Bicycle Shops",
    restricted: false,
  },
  {
    mcc: "7932",
    key: "billiard_pool_establishments",
    label: "Billiard/Pool Establishments",
    restricted: false,
  },
  {
    mcc: "5551",
    key: "boat_dealers",
    label: "Boat Dealers",
    restricted: false,
  },
  {
    mcc: "4457",
    key: "boat_rentals_and_leases",
    label: "Boat Rentals and Leases",
    restricted: false,
  },
  {
    mcc: "5942",
    key: "book_stores",
    label: "Book Stores",
    restricted: false,
  },
  {
    mcc: "5192",
    key: "books_periodicals_and_newspapers",
    label: "Books, Periodicals, and Newspapers",
    restricted: false,
  },
  {
    mcc: "7933",
    key: "bowling_alleys",
    label: "Bowling Alleys",
    restricted: false,
  },
  {
    mcc: "4131",
    key: "bus_lines",
    label: "Bus Lines",
    restricted: false,
  },
  {
    mcc: "8244",
    key: "business_secretarial_schools",
    label: "Business/Secretarial Schools",
    restricted: false,
  },
  {
    mcc: "7278",
    key: "buying_shopping_services",
    label: "Buying/Shopping Services",
    restricted: false,
  },
  {
    mcc: "4899",
    key: "cable_satellite_and_other_pay_television_and_radio",
    label: "Cable, Satellite, and Other Pay Television and Radio",
    restricted: false,
  },
  {
    mcc: "5946",
    key: "camera_and_photographic_supply_stores",
    label: "Camera and Photographic Supply Stores",
    restricted: false,
  },
  {
    mcc: "5441",
    key: "candy_nut_and_confectionery_stores",
    label: "Candy, Nut, and Confectionery Stores",
    restricted: false,
  },
  {
    mcc: "7512",
    key: "car_rental_agencies",
    label: "Car Rental Agencies",
    restricted: false,
  },
  {
    mcc: "7542",
    key: "car_washes",
    label: "Car Washes",
    restricted: false,
  },
  {
    mcc: "5511",
    key: "car_and_truck_dealers_new_used",
    label:
      "Car and Truck Dealers (New & Used) Sales, Service, Repairs Parts and Leasing",
    restricted: false,
  },
  {
    mcc: "5521",
    key: "car_and_truck_dealers_used_only",
    label:
      "Car and Truck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing",
    restricted: false,
  },
  {
    mcc: "1750",
    key: "carpentry_services",
    label: "Carpentry Services",
    restricted: false,
  },
  {
    mcc: "7217",
    key: "carpet_upholstery_cleaning",
    label: "Carpet/Upholstery Cleaning",
    restricted: false,
  },
  {
    mcc: "5811",
    key: "caterers",
    label: "Caterers",
    restricted: false,
  },
  {
    mcc: "8398",
    key: "charitable_and_social_service_organizations_fundraising",
    label: "Charitable and Social Service Organizations - Fundraising",
    restricted: true,
  },
  {
    mcc: "5169",
    key: "chemicals_and_allied_products",
    label: "Chemicals and Allied Products (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "8351",
    key: "child_care_services",
    label: "Child Care Services",
    restricted: false,
  },
  {
    mcc: "5641",
    key: "childrens_and_infants_wear_stores",
    label: "Childrens and Infants Wear Stores",
    restricted: false,
  },
  {
    mcc: "8049",
    key: "chiropodists_podiatrists",
    label: "Chiropodists, Podiatrists",
    restricted: true,
  },
  {
    mcc: "8041",
    key: "chiropractors",
    label: "Chiropractors",
    restricted: true,
  },
  {
    mcc: "5993",
    key: "cigar_stores_and_stands",
    label: "Cigar Stores and Stands",
    restricted: true,
  },
  {
    mcc: "8641",
    key: "civic_social_fraternal_associations",
    label: "Civic, Social, Fraternal Associations",
    restricted: false,
  },
  {
    mcc: "7349",
    key: "cleaning_and_maintenance",
    label: "Cleaning and Maintenance",
    restricted: false,
  },
  {
    mcc: "7296",
    key: "clothing_rental",
    label: "Clothing Rental",
    restricted: false,
  },
  {
    mcc: "8220",
    key: "colleges_universities",
    label: "Colleges, Universities",
    restricted: false,
  },
  {
    mcc: "5046",
    key: "commercial_equipment",
    label: "Commercial Equipment (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "5139",
    key: "commercial_footwear",
    label: "Commercial Footwear",
    restricted: false,
  },
  {
    mcc: "7333",
    key: "commercial_photography_art_and_graphics",
    label: "Commercial Photography, Art and Graphics",
    restricted: false,
  },
  {
    mcc: "4111",
    key: "commuter_transport_and_ferries",
    label: "Commuter Transport, Ferries",
    restricted: false,
  },
  {
    mcc: "4816",
    key: "computer_network_services",
    label: "Computer Network Services",
    restricted: false,
  },
  {
    mcc: "7372",
    key: "computer_programming",
    label: "Computer Programming",
    restricted: false,
  },
  {
    mcc: "7379",
    key: "computer_repair",
    label: "Computer Repair",
    restricted: false,
  },
  {
    mcc: "5734",
    key: "computer_software_stores",
    label: "Computer Software Stores",
    restricted: false,
  },
  {
    mcc: "5045",
    key: "computers_peripherals_and_software",
    label: "Computers, Peripherals, and Software",
    restricted: false,
  },
  {
    mcc: "1771",
    key: "concrete_work_services",
    label: "Concrete Work Services",
    restricted: false,
  },
  {
    mcc: "5039",
    key: "construction_materials",
    label: "Construction Materials (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "7392",
    key: "consulting_public_relations",
    label: "Consulting, Public Relations",
    restricted: false,
  },
  {
    mcc: "8241",
    key: "correspondence_schools",
    label: "Correspondence Schools",
    restricted: false,
  },
  {
    mcc: "5977",
    key: "cosmetic_stores",
    label: "Cosmetic Stores",
    restricted: false,
  },
  {
    mcc: "7277",
    key: "counseling_services",
    label: "Counseling Services",
    restricted: true,
  },
  {
    mcc: "7997",
    key: "country_clubs",
    label: "Country Clubs",
    restricted: false,
  },
  {
    mcc: "4215",
    key: "courier_services",
    label: "Courier Services",
    restricted: false,
  },
  {
    mcc: "9211",
    key: "court_costs",
    label: "Court Costs, Including Alimony and Child Support - Courts of Law",
    restricted: true,
  },
  {
    mcc: "7321",
    key: "credit_reporting_agencies",
    label: "Credit Reporting Agencies",
    restricted: false,
  },
  {
    mcc: "4411",
    key: "cruise_lines",
    label: "Cruise Lines",
    restricted: true,
  },
  {
    mcc: "5451",
    key: "dairy_products_stores",
    label: "Dairy Products Stores",
    restricted: false,
  },
  {
    mcc: "7911",
    key: "dance_hall_studios_schools",
    label: "Dance Hall, Studios, Schools",
    restricted: false,
  },
  {
    mcc: "8021",
    key: "dentists_orthodontists",
    label: "Dentists, Orthodontists",
    restricted: true,
  },
  {
    mcc: "5311",
    key: "department_stores",
    label: "Department Stores",
    restricted: false,
  },
  {
    mcc: "7393",
    key: "detective_agencies",
    label: "Detective Agencies",
    restricted: false,
  },
  {
    mcc: "5815",
    key: "digital_goods_media",
    label: "Digital Goods Media – Books, Movies, Music",
    restricted: false,
  },
  {
    mcc: "5817",
    key: "digital_goods_applications",
    label: "Digital Goods – Applications (Excludes Games)",
    restricted: false,
  },
  {
    mcc: "5816",
    key: "digital_goods_games",
    label: "Digital Goods – Games",
    restricted: false,
  },
  {
    mcc: "5818",
    key: "digital_goods_large_volume",
    label: "Digital Goods – Large Digital Goods Merchant",
    restricted: false,
  },
  {
    mcc: "5964",
    key: "direct_marketing_catalog_merchant",
    label: "Direct Marketing - Catalog Merchant",
    restricted: false,
  },
  {
    mcc: "5965",
    key: "direct_marketing_combination_catalog_and_retail_merchant",
    label: "Direct Marketing - Combination Catalog and Retail Merchant",
    restricted: false,
  },
  {
    mcc: "5967",
    key: "direct_marketing_inbound_telemarketing",
    label: "Direct Marketing - Inbound Telemarketing",
    restricted: true,
  },
  {
    mcc: "5960",
    key: "direct_marketing_insurance_services",
    label: "Direct Marketing - Insurance Services",
    restricted: false,
  },
  {
    mcc: "5969",
    key: "direct_marketing_other",
    label: "Direct Marketing - Other",
    restricted: false,
  },
  {
    mcc: "5966",
    key: "direct_marketing_outbound_telemarketing",
    label: "Direct Marketing - Outbound Telemarketing",
    restricted: true,
  },
  {
    mcc: "5968",
    key: "direct_marketing_subscription",
    label: "Direct Marketing - Subscription",
    restricted: false,
  },
  {
    mcc: "5962",
    key: "direct_marketing_travel",
    label: "Direct Marketing - Travel",
    restricted: true,
  },
  {
    mcc: "5310",
    key: "discount_stores",
    label: "Discount Stores",
    restricted: false,
  },
  {
    mcc: "8011",
    key: "doctors",
    label: "Doctors",
    restricted: true,
  },
  {
    mcc: "5963",
    key: "door_to_door_sales",
    label: "Door-To-Door Sales",
    restricted: true,
  },
  {
    mcc: "5714",
    key: "drapery_window_covering_and_upholstery_stores",
    label: "Drapery, Window Covering, and Upholstery Stores",
    restricted: false,
  },
  {
    mcc: "5813",
    key: "drinking_places",
    label: "Drinking Places",
    restricted: false,
  },
  {
    mcc: "5912",
    key: "drug_stores_and_pharmacies",
    label: "Drug Stores and Pharmacies",
    restricted: true,
  },
  {
    mcc: "5122",
    key: "drugs_drug_proprietaries_and_druggist_sundries",
    label: "Drugs, Drug Proprietaries, and Druggist Sundries",
    restricted: true,
  },
  {
    mcc: "7216",
    key: "dry_cleaners",
    label: "Dry Cleaners",
    restricted: false,
  },
  {
    mcc: "5099",
    key: "durable_goods",
    label: "Durable Goods (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "5309",
    key: "duty_free_stores",
    label: "Duty Free Stores",
    restricted: false,
  },
  {
    mcc: "5812",
    key: "eating_places_restaurants",
    label: "Eating Places, Restaurants",
    restricted: false,
  },
  {
    mcc: "8299",
    key: "educational_services",
    label: "Educational Services",
    restricted: false,
  },
  {
    mcc: "5997",
    key: "electric_razor_stores",
    label: "Electric Razor Stores",
    restricted: false,
  },
  {
    mcc: "5552",
    key: "electric_vehicle_charging",
    label: "Electric Vehicle Charging",
    restricted: false,
  },
  {
    mcc: "5065",
    key: "electrical_parts_and_equipment",
    label: "Electrical Parts and Equipment",
    restricted: false,
  },
  {
    mcc: "1731",
    key: "electrical_services",
    label: "Electrical Services",
    restricted: false,
  },
  {
    mcc: "7622",
    key: "electronics_repair_shops",
    label: "Electronics Repair Shops",
    restricted: false,
  },
  {
    mcc: "5732",
    key: "electronics_stores",
    label: "Electronics Stores",
    restricted: false,
  },
  {
    mcc: "8211",
    key: "elementary_secondary_schools",
    label: "Elementary, Secondary Schools",
    restricted: false,
  },
  {
    mcc: "9702",
    key: "emergency_services_gcas_visa_use_only",
    label: "Emergency Services (GCAS) (Visa use only)",
    restricted: false,
  },
  {
    mcc: "7361",
    key: "employment_temp_agencies",
    label: "Employment/Temp Agencies",
    restricted: false,
  },
  {
    mcc: "7394",
    key: "equipment_rental",
    label: "Equipment Rental",
    restricted: false,
  },
  {
    mcc: "7342",
    key: "exterminating_services",
    label: "Exterminating Services",
    restricted: false,
  },
  {
    mcc: "5651",
    key: "family_clothing_stores",
    label: "Family Clothing Stores",
    restricted: false,
  },
  {
    mcc: "5814",
    key: "fast_food_restaurants",
    label: "Fast Food Restaurants",
    restricted: false,
  },
  {
    mcc: "6012",
    key: "financial_institutions",
    label: "Financial Institutions",
    restricted: true,
  },
  {
    mcc: "9222",
    key: "fines_government_administrative_entities",
    label: "Fines - Government Administrative Entities",
    restricted: true,
  },
  {
    mcc: "5718",
    key: "fireplace_fireplace_screens_and_accessories_stores",
    label: "Fireplace, Fireplace Screens, and Accessories Stores",
    restricted: false,
  },
  {
    mcc: "5713",
    key: "floor_covering_stores",
    label: "Floor Covering Stores",
    restricted: false,
  },
  {
    mcc: "5992",
    key: "florists",
    label: "Florists",
    restricted: false,
  },
  {
    mcc: "5193",
    key: "florists_supplies_nursery_stock_and_flowers",
    label: "Florists Supplies, Nursery Stock, and Flowers",
    restricted: false,
  },
  {
    mcc: "5422",
    key: "freezer_and_locker_meat_provisioners",
    label: "Freezer and Locker Meat Provisioners",
    restricted: false,
  },
  {
    mcc: "5983",
    key: "fuel_dealers_non_automotive",
    label: "Fuel Dealers (Non Automotive)",
    restricted: false,
  },
  {
    mcc: "7261",
    key: "funeral_services_crematories",
    label: "Funeral Services, Crematories",
    restricted: false,
  },
  {
    mcc: "7641",
    key: "furniture_repair_refinishing",
    label: "Furniture Repair, Refinishing",
    restricted: false,
  },
  {
    mcc: "5712",
    key: "furniture_home_furnishings_and_equipment_stores_except_appliances",
    label:
      "Furniture, Home Furnishings, and Equipment Stores, Except Appliances",
    restricted: false,
  },
  {
    mcc: "5681",
    key: "furriers_and_fur_shops",
    label: "Furriers and Fur Shops",
    restricted: false,
  },
  {
    mcc: "1520",
    key: "general_services",
    label: "General Services",
    restricted: false,
  },
  {
    mcc: "5947",
    key: "gift_card_novelty_and_souvenir_shops",
    label: "Gift, Card, Novelty, and Souvenir Shops",
    restricted: false,
  },
  {
    mcc: "5231",
    key: "glass_paint_and_wallpaper_stores",
    label: "Glass, Paint, and Wallpaper Stores",
    restricted: false,
  },
  {
    mcc: "5950",
    key: "glassware_crystal_stores",
    label: "Glassware, Crystal Stores",
    restricted: false,
  },
  {
    mcc: "7992",
    key: "golf_courses_public",
    label: "Golf Courses - Public",
    restricted: false,
  },
  {
    mcc: "7801",
    key: "government_licensed_online_casions_online_gambling_us_region_only",
    label:
      "Government Licensed On-line Casinos (On-Line Gambling)(US Region only)",
    restricted: true,
  },
  {
    mcc: "9399",
    key: "government_services",
    label: "Government Services (Not Elsewhere Classified)",
    restricted: true,
  },
  {
    mcc: "7802",
    key: "government_licensed_horse_dog_racing_us_region_only",
    label: "Government-Licensed Horse/Dog Racing (US Region only)",
    restricted: true,
  },
  {
    mcc: "9406",
    key: "government_owned_lotteries_non_us_region",
    label: "Government-Owned Lotteries (Non-US region)",
    restricted: false,
  },
  {
    mcc: "7800",
    key: "government_owned_lotteries_us_region_only",
    label: "Government-Owned Lotteries (US Region only)",
    restricted: true,
  },
  {
    mcc: "5411",
    key: "grocery_stores_supermarkets",
    label: "Grocery Stores, Supermarkets",
    restricted: false,
  },
  {
    mcc: "5251",
    key: "hardware_stores",
    label: "Hardware Stores",
    restricted: false,
  },
  {
    mcc: "5072",
    key: "hardware_equipment_and_supplies",
    label: "Hardware, Equipment, and Supplies",
    restricted: false,
  },
  {
    mcc: "7298",
    key: "health_and_beauty_spas",
    label: "Health and Beauty Spas",
    restricted: false,
  },
  {
    mcc: "5975",
    key: "hearing_aids_sales_and_supplies",
    label: "Hearing Aids Sales and Supplies",
    restricted: true,
  },
  {
    mcc: "1711",
    key: "heating_plumbing_a_c",
    label: "Heating, Plumbing, A/C",
    restricted: false,
  },
  {
    mcc: "5945",
    key: "hobby_toy_and_game_shops",
    label: "Hobby, Toy, and Game Shops",
    restricted: false,
  },
  {
    mcc: "5200",
    key: "home_supply_warehouse_stores",
    label: "Home Supply Warehouse Stores",
    restricted: false,
  },
  {
    mcc: "8062",
    key: "hospitals",
    label: "Hospitals",
    restricted: true,
  },
  {
    mcc: "7011",
    key: "hotels_motels_and_resorts",
    label: "Hotels, Motels, and Resorts",
    restricted: false,
  },
  {
    mcc: "5722",
    key: "household_appliance_stores",
    label: "Household Appliance Stores",
    restricted: false,
  },
  {
    mcc: "5085",
    key: "industrial_supplies",
    label: "Industrial Supplies (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "7375",
    key: "information_retrieval_services",
    label: "Information Retrieval Services",
    restricted: false,
  },
  {
    mcc: "6300",
    key: "insurance_underwriting_premiums",
    label: "Insurance Underwriting, Premiums",
    restricted: true,
  },
  {
    mcc: "9950",
    key: "intra_company_purchases",
    label: "Intra-Company Purchases",
    restricted: false,
  },
  {
    mcc: "5944",
    key: "jewelry_stores_watches_clocks_and_silverware_stores",
    label: "Jewelry Stores, Watches, Clocks, and Silverware Stores",
    restricted: false,
  },
  {
    mcc: "0780",
    key: "landscaping_services",
    label: "Landscaping Services",
    restricted: false,
  },
  {
    mcc: "7211",
    key: "laundries",
    label: "Laundries",
    restricted: false,
  },
  {
    mcc: "7210",
    key: "laundry_cleaning_services",
    label: "Laundry, Cleaning Services",
    restricted: false,
  },
  {
    mcc: "8111",
    key: "legal_services_attorneys",
    label: "Legal Services, Attorneys",
    restricted: false,
  },
  {
    mcc: "5948",
    key: "luggage_and_leather_goods_stores",
    label: "Luggage and Leather Goods Stores",
    restricted: false,
  },
  {
    mcc: "5211",
    key: "lumber_building_materials_stores",
    label: "Lumber, Building Materials Stores",
    restricted: false,
  },
  {
    mcc: "4468",
    key: "marinas_service_and_supplies",
    label: "Marinas, Service and Supplies",
    restricted: false,
  },
  {
    mcc: "1740",
    key: "masonry_stonework_and_plaster",
    label: "Masonry, Stonework, and Plaster",
    restricted: false,
  },
  {
    mcc: "7297",
    key: "massage_parlors",
    label: "Massage Parlors",
    restricted: false,
  },
  {
    mcc: "8099",
    key: "medical_services",
    label: "Medical Services",
    restricted: true,
  },
  {
    mcc: "8071",
    key: "medical_and_dental_labs",
    label: "Medical and Dental Labs",
    restricted: true,
  },
  {
    mcc: "5047",
    key: "medical_dental_ophthalmic_and_hospital_equipment_and_supplies",
    label: "Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies",
    restricted: true,
  },
  {
    mcc: "8699",
    key: "membership_organizations",
    label: "Membership Organizations",
    restricted: false,
  },
  {
    mcc: "5611",
    key: "mens_and_boys_clothing_and_accessories_stores",
    label: "Mens and Boys Clothing and Accessories Stores",
    restricted: false,
  },
  {
    mcc: "5691",
    key: "mens_womens_clothing_stores",
    label: "Mens, Womens Clothing Stores",
    restricted: false,
  },
  {
    mcc: "5051",
    key: "metal_service_centers",
    label: "Metal Service Centers",
    restricted: false,
  },
  {
    mcc: "5699",
    key: "miscellaneous_apparel_and_accessory_shops",
    label: "Miscellaneous Apparel and Accessory Shops",
    restricted: false,
  },
  {
    mcc: "5599",
    key: "miscellaneous_auto_dealers",
    label: "Miscellaneous Auto Dealers",
    restricted: false,
  },
  {
    mcc: "7399",
    key: "miscellaneous_business_services",
    label: "Miscellaneous Business Services",
    restricted: false,
  },
  {
    mcc: "5499",
    key: "miscellaneous_food_stores",
    label:
      "Miscellaneous Food Stores - Convenience Stores and Specialty Markets",
    restricted: false,
  },
  {
    mcc: "5399",
    key: "miscellaneous_general_merchandise",
    label: "Miscellaneous General Merchandise",
    restricted: false,
  },
  {
    mcc: "7299",
    key: "miscellaneous_general_services",
    label: "Miscellaneous General Services",
    restricted: false,
  },
  {
    mcc: "5719",
    key: "miscellaneous_home_furnishing_specialty_stores",
    label: "Miscellaneous Home Furnishing Specialty Stores",
    restricted: false,
  },
  {
    mcc: "2741",
    key: "miscellaneous_publishing_and_printing",
    label: "Miscellaneous Publishing and Printing",
    restricted: false,
  },
  {
    mcc: "7999",
    key: "miscellaneous_recreation_services",
    label: "Miscellaneous Recreation Services",
    restricted: false,
  },
  {
    mcc: "7699",
    key: "miscellaneous_repair_shops",
    label: "Miscellaneous Repair Shops",
    restricted: false,
  },
  {
    mcc: "5999",
    key: "miscellaneous_specialty_retail",
    label: "Miscellaneous Specialty Retail",
    restricted: false,
  },
  {
    mcc: "5271",
    key: "mobile_home_dealers",
    label: "Mobile Home Dealers",
    restricted: false,
  },
  {
    mcc: "7832",
    key: "motion_picture_theaters",
    label: "Motion Picture Theaters",
    restricted: false,
  },
  {
    mcc: "4214",
    key: "motor_freight_carriers_and_trucking",
    label:
      "Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery Services",
    restricted: false,
  },
  {
    mcc: "5592",
    key: "motor_homes_dealers",
    label: "Motor Homes Dealers",
    restricted: false,
  },
  {
    mcc: "5013",
    key: "motor_vehicle_supplies_and_new_parts",
    label: "Motor Vehicle Supplies and New Parts",
    restricted: false,
  },
  {
    mcc: "5571",
    key: "motorcycle_shops_and_dealers",
    label: "Motorcycle Shops and Dealers",
    restricted: false,
  },
  {
    mcc: "5561",
    key: "motorcycle_shops_dealers",
    label: "Motorcycle Shops, Dealers",
    restricted: false,
  },
  {
    mcc: "5733",
    key: "music_stores_musical_instruments_pianos_and_sheet_music",
    label: "Music Stores-Musical Instruments, Pianos, and Sheet Music",
    restricted: false,
  },
  {
    mcc: "5994",
    key: "news_dealers_and_newsstands",
    label: "News Dealers and Newsstands",
    restricted: false,
  },
  {
    mcc: "6051",
    key: "non_fi_money_orders",
    label: "Non-FI, Money Orders",
    restricted: true,
  },
  {
    mcc: "6540",
    key: "non_fi_stored_value_card_purchase_load",
    label: "Non-FI, Stored Value Card Purchase/Load",
    restricted: true,
  },
  {
    mcc: "5199",
    key: "nondurable_goods",
    label: "Nondurable Goods (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "5261",
    key: "nurseries_lawn_and_garden_supply_stores",
    label: "Nurseries, Lawn and Garden Supply Stores",
    restricted: false,
  },
  {
    mcc: "8050",
    key: "nursing_personal_care",
    label: "Nursing/Personal Care",
    restricted: true,
  },
  {
    mcc: "5021",
    key: "office_and_commercial_furniture",
    label: "Office and Commercial Furniture",
    restricted: false,
  },
  {
    mcc: "8043",
    key: "opticians_eyeglasses",
    label: "Opticians, Eyeglasses",
    restricted: true,
  },
  {
    mcc: "8042",
    key: "optometrists_ophthalmologist",
    label: "Optometrists, Ophthalmologist",
    restricted: true,
  },
  {
    mcc: "5976",
    key: "orthopedic_goods_prosthetic_devices",
    label: "Orthopedic Goods - Prosthetic Devices",
    restricted: true,
  },
  {
    mcc: "8031",
    key: "osteopaths",
    label: "Osteopaths",
    restricted: true,
  },
  {
    mcc: "5921",
    key: "package_stores_beer_wine_and_liquor",
    label: "Package Stores-Beer, Wine, and Liquor",
    restricted: false,
  },
  {
    mcc: "5198",
    key: "paints_varnishes_and_supplies",
    label: "Paints, Varnishes, and Supplies",
    restricted: false,
  },
  {
    mcc: "7523",
    key: "parking_lots_garages",
    label: "Parking Lots, Garages",
    restricted: false,
  },
  {
    mcc: "4112",
    key: "passenger_railways",
    label: "Passenger Railways",
    restricted: false,
  },
  {
    mcc: "5933",
    key: "pawn_shops",
    label: "Pawn Shops",
    restricted: false,
  },
  {
    mcc: "5995",
    key: "pet_shops_pet_food_and_supplies",
    label: "Pet Shops, Pet Food, and Supplies",
    restricted: false,
  },
  {
    mcc: "5172",
    key: "petroleum_and_petroleum_products",
    label: "Petroleum and Petroleum Products",
    restricted: false,
  },
  {
    mcc: "7395",
    key: "photo_developing",
    label: "Photo Developing",
    restricted: false,
  },
  {
    mcc: "7221",
    key: "photographic_studios",
    label: "Photographic Studios",
    restricted: false,
  },
  {
    mcc: "5044",
    key: "photographic_photocopy_microfilm_equipment_and_supplies",
    label: "Photographic, Photocopy, Microfilm Equipment, and Supplies",
    restricted: false,
  },
  {
    mcc: "7829",
    key: "picture_video_production",
    label: "Picture/Video Production",
    restricted: false,
  },
  {
    mcc: "5131",
    key: "piece_goods_notions_and_other_dry_goods",
    label: "Piece Goods, Notions, and Other Dry Goods",
    restricted: false,
  },
  {
    mcc: "5074",
    key: "plumbing_heating_equipment_and_supplies",
    label: "Plumbing, Heating Equipment, and Supplies",
    restricted: false,
  },
  {
    mcc: "8651",
    key: "political_organizations",
    label: "Political Organizations",
    restricted: true,
  },
  {
    mcc: "9402",
    key: "postal_services_government_only",
    label: "Postal Services - Government Only",
    restricted: true,
  },
  {
    mcc: "5094",
    key: "precious_stones_and_metals_watches_and_jewelry",
    label: "Precious Stones and Metals, Watches and Jewelry",
    restricted: false,
  },
  {
    mcc: "8999",
    key: "professional_services",
    label: "Professional Services",
    restricted: false,
  },
  {
    mcc: "4225",
    key: "public_warehousing_and_storage",
    label:
      "Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage",
    restricted: false,
  },
  {
    mcc: "7338",
    key: "quick_copy_repro_and_blueprint",
    label: "Quick Copy, Repro, and Blueprint",
    restricted: false,
  },
  {
    mcc: "4011",
    key: "railroads",
    label: "Railroads",
    restricted: false,
  },
  {
    mcc: "6513",
    key: "real_estate_agents_and_managers_rentals",
    label: "Real Estate Agents and Managers - Rentals",
    restricted: false,
  },
  {
    mcc: "5735",
    key: "record_stores",
    label: "Record Stores",
    restricted: false,
  },
  {
    mcc: "7519",
    key: "recreational_vehicle_rentals",
    label: "Recreational Vehicle Rentals",
    restricted: false,
  },
  {
    mcc: "5973",
    key: "religious_goods_stores",
    label: "Religious Goods Stores",
    restricted: false,
  },
  {
    mcc: "8661",
    key: "religious_organizations",
    label: "Religious Organizations",
    restricted: true,
  },
  {
    mcc: "1761",
    key: "roofing_siding_sheet_metal",
    label: "Roofing/Siding, Sheet Metal",
    restricted: false,
  },
  {
    mcc: "7339",
    key: "secretarial_support_services",
    label: "Secretarial Support Services",
    restricted: false,
  },
  {
    mcc: "6211",
    key: "security_brokers_dealers",
    label: "Security Brokers/Dealers",
    restricted: true,
  },
  {
    mcc: "5541",
    key: "service_stations",
    label: "Service Stations",
    restricted: false,
  },
  {
    mcc: "5949",
    key: "sewing_needlework_fabric_and_piece_goods_stores",
    label: "Sewing, Needlework, Fabric, and Piece Goods Stores",
    restricted: false,
  },
  {
    mcc: "7251",
    key: "shoe_repair_hat_cleaning",
    label: "Shoe Repair/Hat Cleaning",
    restricted: false,
  },
  {
    mcc: "5661",
    key: "shoe_stores",
    label: "Shoe Stores",
    restricted: false,
  },
  {
    mcc: "7629",
    key: "small_appliance_repair",
    label: "Small Appliance Repair",
    restricted: false,
  },
  {
    mcc: "5598",
    key: "snowmobile_dealers",
    label: "Snowmobile Dealers",
    restricted: false,
  },
  {
    mcc: "1799",
    key: "special_trade_services",
    label: "Special Trade Services",
    restricted: false,
  },
  {
    mcc: "2842",
    key: "specialty_cleaning",
    label: "Specialty Cleaning",
    restricted: false,
  },
  {
    mcc: "5941",
    key: "sporting_goods_stores",
    label: "Sporting Goods Stores",
    restricted: false,
  },
  {
    mcc: "7032",
    key: "sporting_recreation_camps",
    label: "Sporting/Recreation Camps",
    restricted: false,
  },
  {
    mcc: "7941",
    key: "sports_clubs_fields",
    label: "Sports Clubs/Fields",
    restricted: false,
  },
  {
    mcc: "5655",
    key: "sports_and_riding_apparel_stores",
    label: "Sports and Riding Apparel Stores",
    restricted: false,
  },
  {
    mcc: "5972",
    key: "stamp_and_coin_stores",
    label: "Stamp and Coin Stores",
    restricted: false,
  },
  {
    mcc: "5943",
    key: "stationery_stores_office_and_school_supply_stores",
    label: "Stationery Stores, Office, and School Supply Stores",
    restricted: false,
  },
  {
    mcc: "5111",
    key: "stationary_office_supplies_printing_and_writing_paper",
    label: "Stationery, Office Supplies, Printing and Writing Paper",
    restricted: false,
  },
  {
    mcc: "5996",
    key: "swimming_pools_sales",
    label: "Swimming Pools Sales",
    restricted: false,
  },
  {
    mcc: "4723",
    key: "t_ui_travel_germany",
    label: "TUI Travel - Germany",
    restricted: false,
  },
  {
    mcc: "5697",
    key: "tailors_alterations",
    label: "Tailors, Alterations",
    restricted: false,
  },
  {
    mcc: "9311",
    key: "tax_payments_government_agencies",
    label: "Tax Payments - Government Agencies",
    restricted: true,
  },
  {
    mcc: "7276",
    key: "tax_preparation_services",
    label: "Tax Preparation Services",
    restricted: false,
  },
  {
    mcc: "4121",
    key: "taxicabs_limousines",
    label: "Taxicabs/Limousines",
    restricted: false,
  },
  {
    mcc: "4812",
    key: "telecommunication_equipment_and_telephone_sales",
    label: "Telecommunication Equipment and Telephone Sales",
    restricted: false,
  },
  {
    mcc: "4814",
    key: "telecommunication_services",
    label: "Telecommunication Services",
    restricted: true,
  },
  {
    mcc: "4821",
    key: "telegraph_services",
    label: "Telegraph Services",
    restricted: false,
  },
  {
    mcc: "5998",
    key: "tent_and_awning_shops",
    label: "Tent and Awning Shops",
    restricted: false,
  },
  {
    mcc: "8734",
    key: "testing_laboratories",
    label: "Testing Laboratories",
    restricted: false,
  },
  {
    mcc: "7922",
    key: "theatrical_ticket_agencies",
    label: "Theatrical Ticket Agencies",
    restricted: false,
  },
  {
    mcc: "7012",
    key: "timeshares",
    label: "Timeshares",
    restricted: true,
  },
  {
    mcc: "7534",
    key: "tire_retreading_and_repair",
    label: "Tire Retreading and Repair",
    restricted: false,
  },
  {
    mcc: "4784",
    key: "tolls_bridge_fees",
    label: "Tolls/Bridge Fees",
    restricted: false,
  },
  {
    mcc: "7991",
    key: "tourist_attractions_and_exhibits",
    label: "Tourist Attractions and Exhibits",
    restricted: false,
  },
  {
    mcc: "7549",
    key: "towing_services",
    label: "Towing Services",
    restricted: false,
  },
  {
    mcc: "7033",
    key: "trailer_parks_campgrounds",
    label: "Trailer Parks, Campgrounds",
    restricted: false,
  },
  {
    mcc: "4789",
    key: "transportation_services",
    label: "Transportation Services (Not Elsewhere Classified)",
    restricted: false,
  },
  {
    mcc: "4722",
    key: "travel_agencies_tour_operators",
    label: "Travel Agencies, Tour Operators",
    restricted: false,
  },
  {
    mcc: "7513",
    key: "truck_utility_trailer_rentals",
    label: "Truck/Utility Trailer Rentals",
    restricted: false,
  },
  {
    mcc: "2791",
    key: "typesetting_plate_making_and_related_services",
    label: "Typesetting, Plate Making, and Related Services",
    restricted: false,
  },
  {
    mcc: "5978",
    key: "typewriter_stores",
    label: "Typewriter Stores",
    restricted: false,
  },
  {
    mcc: "9405",
    key: "u_s_federal_government_agencies_or_departments",
    label: "U.S. Federal Government Agencies or Departments",
    restricted: true,
  },
  {
    mcc: "5137",
    key: "uniforms_commercial_clothing",
    label: "Uniforms, Commercial Clothing",
    restricted: false,
  },
  {
    mcc: "5931",
    key: "used_merchandise_and_secondhand_stores",
    label: "Used Merchandise and Secondhand Stores",
    restricted: false,
  },
  {
    mcc: "4900",
    key: "utilities",
    label: "Utilities",
    restricted: false,
  },
  {
    mcc: "5331",
    key: "variety_stores",
    label: "Variety Stores",
    restricted: false,
  },
  {
    mcc: "0742",
    key: "veterinary_services",
    label: "Veterinary Services",
    restricted: false,
  },
  {
    mcc: "7993",
    key: "video_amusement_game_supplies",
    label: "Video Amusement Game Supplies",
    restricted: false,
  },
  {
    mcc: "7994",
    key: "video_game_arcades",
    label: "Video Game Arcades",
    restricted: false,
  },
  {
    mcc: "7841",
    key: "video_tape_rental_stores",
    label: "Video Tape Rental Stores",
    restricted: false,
  },
  {
    mcc: "8249",
    key: "vocational_trade_schools",
    label: "Vocational/Trade Schools",
    restricted: false,
  },
  {
    mcc: "7631",
    key: "watch_jewelry_repair",
    label: "Watch/Jewelry Repair",
    restricted: false,
  },
  {
    mcc: "7692",
    key: "welding_repair",
    label: "Welding Repair",
    restricted: false,
  },
  {
    mcc: "5300",
    key: "wholesale_clubs",
    label: "Wholesale Clubs",
    restricted: false,
  },
  {
    mcc: "5698",
    key: "wig_and_toupee_stores",
    label: "Wig and Toupee Stores",
    restricted: false,
  },
  {
    mcc: "4829",
    key: "wires_money_orders",
    label: "Wires, Money Orders",
    restricted: true,
  },
  {
    mcc: "5631",
    key: "womens_accessory_and_specialty_shops",
    label: "Womens Accessory and Specialty Shops",
    restricted: false,
  },
  {
    mcc: "5621",
    key: "womens_ready_to_wear_stores",
    label: "Womens Ready-To-Wear Stores",
    restricted: false,
  },
  {
    mcc: "5935",
    key: "wrecking_and_salvage_yards",
    label: "Wrecking and Salvage Yards",
    restricted: false,
  },
];

export const stripeMccValues = new Set(
  stripeMccOptions.map((option) => option.mcc),
);
